import React from 'react';
import TextField from 'material-ui/TextField';
import Slider from 'material-ui/Slider';
import DatePicker from 'material-ui/DatePicker';
import SelectField from 'material-ui/SelectField';
import moment from 'moment';
import { fromJS } from 'immutable';
import _ from 'lodash';

import CreateJobResourcesTable from '../components/CreateJobDialog/ResourcesTable';
import ResourcesTable from '../components/ResourcesTable';
import JobProfileDrilldown from '../components/JobProfileDrilldown';
import { toArray, toMap } from '../utils/helper';
import StagesTable from '../components/JobProfile/StagesTable';
import QuestionsTable from '../components/QuestionsTable';
import ItemTypesTable from '../components/TaskProfile/ItemTypesTable';

export const renderTextField = ({ input, label, meta: { touched, error }, ...custom }) => {
  return (
    <TextField
      hintText={label}
      floatingLabelText={label}
      errorText={touched && error}
      {...input}
      {...custom}
    />);
};

export const renderSlider = ({ input, meta: { touched, error }, ...custom }) => {
  console.log('input', input);
  console.log('custom', custom);
  return (
    <Slider
      {...input}
      {...custom}
      value={Math.max(Number(input.value || 0), custom.min)}
      onChange={(evt, newVal) => {
        console.log('newVal', newVal);
        input.onChange(Number(newVal));
      }}
    />);
};

export const renderSelectField = ({ input, label, meta: { touched, error }, children, ...custom }) => {
  return (<SelectField
    floatingLabelText={label}
    errorText={touched && error}
    {...input}
    onChange={(event, index, value) => input.onChange(value)}
    {...custom}
  >{children}</SelectField>);
};

export const renderDatePicker = ({ input: { value, onChange, ...inputProps }, label, defaultDate, meta: { touched, error, warning }, ...custom }) => {
  return (<DatePicker
    floatingLabelText={label}
    errorText={touched && error}
    {..._.assign(inputProps, { value: moment(value).toDate() })}
    onChange={(event, val) => onChange(val)}
    {...custom}
  />);
};

export const renderJobProfileDrilldown = ({ input, meta: { touched, error } }) => {
  return (<div>
    { touched && error ? <div style={{ color: 'red' }}>{error}</div> : null }
    <JobProfileDrilldown
      jobProfile={input.value || {}}
      onChange={input.onChange} />
  </div>);
};

export const renderCreateJobResources = ({ input }) => {
  return (<CreateJobResourcesTable
    resources={toArray(input.value) || []}
    onChange={(resources) => input.onChange(toMap(resources))}/>);
};

export const renderResources = ({ input: { value, onChange}, employees, editable }) => {
  return (<ResourcesTable
    resources={value ? toArray(value.toJS()) : []}
    onChange={(resources) => onChange(fromJS(toMap(resources)))}
    editable={editable}
    employees={employees}
  />);
};

export const renderJobProfileStages = ({ input }) => {
  return (<StagesTable
    stages={input.value ? input.value.toJS() : []}
    onChange={(stages) => input.onChange(fromJS(stages))}/>);
};

export const renderJobProfileQualityControlQuestions = ({ input }) => {
  return (<QuestionsTable
    questions={input.value ? input.value.toJS() : []}
    onChange={(questions) => input.onChange(fromJS(questions))}/>);
};

export const renderTaskProfileItemTypes = ({ input }) => {
  return (<ItemTypesTable
    counts={input.value ? input.value.toJS() : {}}
    onChange={(counts) => input.onChange(fromJS(counts))}/>);
};

export const renderTasksForCount = ({ input }) => {
  return (<ItemTypesTable
    counts={input.value ? input.value.toJS() : {}}
    onChange={(counts) => input.onChange(fromJS(counts))}/>);
};



// WEBPACK FOOTER //
// ./src/utils/reduxforms.js